import service from '@/utils/request';

//游戏公告添加
export var addNotice = function addNotice(data) {
  return service({
    url: "/xcpOpsManager/gameNotice/addNotice",
    method: 'post',
    data: data
  });
};

//游戏公告列表
export var getList = function getList(data) {
  return service({
    url: "/xcpOpsManager/gameNotice/getList",
    method: 'post',
    data: data
  });
};

//游戏公告修改
export var updateNotice = function updateNotice(data) {
  return service({
    url: "/xcpOpsManager/gameNotice/updateNotice",
    method: 'post',
    data: data
  });
};